<template>
  <IndexHeader />
  <HomePageTop />
  <HomePageMain />
  <HomePageBottomAbout />
  <HomePageFooter />
  
</template>

<script>
// 首页顶部导航栏
import IndexHeader from "../components/IndexHeader/TopBar";
// 首页置顶大图
import HomePageTop from "../components/HomePageTop/Top";
// 首页内容主体
import HomePageMain from "../components/HomePageMain/Main";
// 首页底部关于
import HomePageBottomAbout from "../components/HomePageBottomAbout/About";
// 首页底部Footer
import HomePageFooter from "../components/HomePageFooter/Footer";

export default {
  name: "HomePage",
  components: {
    IndexHeader,
    HomePageTop,
    HomePageMain,
    HomePageBottomAbout,
    HomePageFooter,
  },
  mounted() {
  },
};
</script>

<style scoped>
</style>